import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import Layout from './components/Layout';
import HomePage from './pages/HomePage';
import SearchPage from './pages/SearchPage';
import PropertyDetailPage from './pages/PropertyDetailPage';
import DashboardPage from './pages/DashboardPage';
import AdminPanelNew from './pages/AdminPanelNew';
import LoginPage from './pages/LoginPage';
import ProtectedRoute from './components/ProtectedRoute';
import TelegramDebug from './components/TelegramDebug';

function App() {
  useEffect(() => {
    // Make webapp fullscreen on Telegram
    if (window.Telegram?.WebApp) {
      window.Telegram.WebApp.expand();
      window.Telegram.WebApp.requestFullscreen();
      window.Telegram.WebApp.enableClosingConfirmation();
    }
  }, []);

  return (
    <LanguageProvider>
      <Router>
        <AuthProvider>
          <Layout>
            <Routes>
              <Route path="/debug" element={<TelegramDebug />} />
              <Route path="/" element={<HomePage />} />
              <Route path="/search" element={<SearchPage />} />
              <Route path="/property/:id" element={<PropertyDetailPage />} />
              <Route path="/login" element={<LoginPage />} />

              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <DashboardPage />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/admin"
                element={
                  <ProtectedRoute adminOnly>
                    <AdminPanelNew />
                  </ProtectedRoute>
                }
              />

              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </Layout>
        </AuthProvider>
      </Router>
    </LanguageProvider>
  );
}

export default App;
